import Cookie from 'lib/cookie';

export default Cookie.create({
  adapter: 'localstorage',
});
